import team1 from "../images/team/team1.png";
import team2 from "../images/team/team2.png";
import team3 from "../images/team/team3.png";
import team4 from "../images/team/team4.png";
import team5 from "../images/team/team5.png";
import team6 from "../images/team/team6.png";
import team7 from "../images/team/team7.png";
import team8 from "../images/team/team8.png";
import flag from "../images/flag.svg";
import folder from "../images/folder.svg";
import sms from "../images/message.svg";
import user from "../images/user.svg";

export const companyData = [
  {
    company: "Company1",
    title: "Layers",
    text: "“Knoct has saved us thousands of hours of work. We're able to spin up projects faster.”",
    link: "",
  },
  {
    company: "Company2",
    title: "Slack",
    text: "“We’ve been using Knoct to kick start every new project and can’t work without it.”",
    link: "",
  },
  {
    company: "Company3",
    title: "Layers",
    text: "“Love the simplicity of the service and the prompt customer support.”",
    link: "",
  },
  {
    company: "Company4",
    title: "Layers",
    text: "Knoct has saved us thousands of hours of work. We're able to spin up projects faster.",
    link: "",
  },
  {
    company: "Company5",
    title: "Layers",
    text: "Knoct has saved us thousands of hours of work. We're able to spin up projects faster.",
    link: "",
  },
  {
    company: "Company6",
    title: "Layers",
    text: "Knoct has saved us thousands of hours of work. We're able to spin up projects faster.",
    link: "",
  },
  {
    company: "Company7",
    title: "Layers",
    text: "Knoct has saved us thousands of hours of work. We're able to spin up projects faster.",
    link: "",
  },
  {
    company: "Company8",
    title: "Layers",
    text: "Knoct has saved us thousands of hours of work. We're able to spin up projects faster.",
    link: "",
  },
];

export const teams = [
  {
    id: 1,
    img: team1,
    name: "Nirdesh Dwa",
    title: "Co-founder & CEO",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
  {
    id: 2,
    img: team2,
    name: "Vedanth Pedigelwar",
    title: "CEO & Co-founder",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
  {
    id: 3,
    img: team3,
    name: "Mary Doe",
    title: "CXX",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
  {
    id: 4,
    img: team4,
    name: "John Doe",
    title: "CXX",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
  {
    id: 5,
    img: team5,
    name: "John Doe",
    title: "Chief Developer",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
  {
    id: 6,
    img: team6,
    name: "John Doe",
    title: "Chief Product Designer",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
  {
    id: 7,
    img: team7,
    name: "Marry Doe",
    title: "Chief Ux Researcher",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
  {
    id: 8,
    img: team8,
    name: "John Doe",
    title: "Chief Customer Success",
    text: "Former co-founder at Veda App, MIT Bootcamp Alumnus",
    twitter: "",
    linkedin: "",
  },
];

export const positions = [
  {
    title: "Product Designer",
    options: "Design",
    bg: "#EFF8FF",
    color: "#175CD3",
    text: "We're looking for a mid-level product designer to join our team",
    site: "Remote",
    time: "Full-time",
  },
  {
    title: "Customer Success Manager",
    options: "Customer Success",
    bg: "#ECFDF3",
    color: "#027A48",
    text: "We're looking for a mid-level product designer to join our team",
    site: "Remote",
    time: "Full-time",
  },
  {
    title: "SEO Marketing Manager",
    options: "Marketing",
    bg: "#FEF6EE",
    color: "#B93815",
    text: "We're looking for a mid-level product designer to join our team",
    site: "Remote",
    time: "Full-time",
  },
  {
    title: "Engineering Manager",
    options: "Software Development",
    bg: "#EDD6FB",
    color: "#C5237C",
    text: "We're looking for a mid-level product designer to join our team",
    site: "Remote",
    time: "Full-time",
  },
  {
    title: "Account Executive",
    options: "Sales",
    bg: "#EEF4FF",
    color: "#7A7EE0",
    text: "We're looking for a mid-level product designer to join our team",
    site: "Remote",
    time: "Full-time",
  },
  {
    title: "UX Research",
    options: "Design",
    bg: "#EFF8FF",
    color: "#6897E3",
    text: "We're looking for a mid-level product designer to join our team",
    site: "Remote",
    time: "Full-time",
  },
];

export const companyInfo = [
  {
    id: 1,
    icon: flag,
    title: "About us",
    text: "Learn about our story and our mission statement",
    link: "/about",
  },
  {
    id: 2,
    icon: sms,
    title: "Contact Us",
    text: "Find everything you know about Knoct",
    link: "/contact",
  },
  {
    id: 3,
    icon: user,
    title: "Careers",
    options: "We're hiring",
    text: "We're always looking for talented people. Join us!",
    link: "/careers",
  },
  {
    id: 4,
    icon: folder,
    title: "Legal ",
    text: "All the boring stuff that we Dan from legal made us add",
    link: "/legal",
  },
];
